import { HERO_BG, TELEGRAM_URL } from "../lib/config";
import { Button } from "./ui/button";
import { Send, ArrowDown, Truck, Package } from "lucide-react";

export default function Hero() {
    return (
        <section
            data-testid="hero-section"
            className="relative min-h-[92vh] flex items-end overflow-hidden"
        >
            {/* Background */}
            <div className="absolute inset-0">
                <img
                    src={HERO_BG}
                    alt=""
                    className="w-full h-full object-cover scale-105"
                />
                <div
                    className="absolute inset-0"
                    style={{
                        background:
                            "linear-gradient(180deg, rgba(5,5,7,0.55) 0%, rgba(5,5,7,0.4) 40%, rgba(5,5,7,0.85) 80%, rgba(5,5,7,1) 100%)",
                    }}
                />
            </div>

            {/* Content */}
            <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24 pt-32">
                <div className="grid lg:grid-cols-12 gap-8 items-end">
                    <div className="lg:col-span-8 fade-up">
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full glass mb-6">
                            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
                            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/80">
                                Now Delivering · South Jersey
                            </span>
                        </div>
                        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-bold text-white tracking-tighter leading-[0.95] text-balance">
                            Take{" "}
                            <span className="text-highway-red">High95</span>
                            <br />
                            to your{" "}
                            <span className="italic font-light text-white/90">
                                destination
                            </span>
                            <br />
                            in the clouds.
                        </h1>
                        <p className="mt-8 max-w-xl text-base sm:text-lg text-white/65 leading-relaxed">
                            Premium THCA flower & concentrates. Slow-cured,
                            properly priced. Local deliveries across South
                            Jersey only.
                        </p>
                        <div className="mt-10 flex flex-wrap gap-3">
                            <Button
                                data-testid="hero-shop-btn"
                                asChild
                                className="rounded-full bg-highway-red hover:bg-highway-red/90 text-white px-8 py-6 text-base font-semibold glow-red"
                            >
                                <a href="#menu">
                                    Shop the Menu
                                    <ArrowDown className="ml-2 w-4 h-4" />
                                </a>
                            </Button>
                            <Button
                                data-testid="hero-telegram-btn"
                                asChild
                                variant="outline"
                                className="rounded-full bg-transparent border border-white/20 hover:bg-white/10 text-white hover:text-white px-8 py-6 text-base font-semibold"
                            >
                                <a
                                    href={TELEGRAM_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Send className="mr-2 w-4 h-4" />
                                    Order on Telegram
                                </a>
                            </Button>
                        </div>
                    </div>

                    {/* Right column — info pills */}
                    <div className="lg:col-span-4 grid grid-cols-2 lg:grid-cols-1 gap-3 fade-up" style={{ animationDelay: "0.15s" }}>
                        <div className="glass rounded-2xl p-5">
                            <Truck className="w-6 h-6 text-highway-blue mb-3" />
                            <p className="font-mono text-[10px] uppercase tracking-widest text-white/50 mb-1">
                                Local Only
                            </p>
                            <p className="font-display font-semibold text-white text-lg leading-tight">
                                Same-day
                                <br />
                                delivery
                            </p>
                        </div>
                        <div className="glass rounded-2xl p-5">
                            <Package className="w-6 h-6 text-highway-sunset mb-3" />
                            <p className="font-mono text-[10px] uppercase tracking-widest text-white/50 mb-1">
                                South Jersey
                            </p>
                            <p className="font-display font-semibold text-white text-lg leading-tight">
                                Premium
                                <br />
                                THCA
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Marquee strip */}
            <div className="absolute bottom-0 left-0 right-0 z-20 border-y border-white/10 bg-black/60 backdrop-blur-md py-3 overflow-hidden">
                <div className="scroll-marquee whitespace-nowrap flex gap-12 font-mono text-xs uppercase tracking-[0.3em] text-white/60">
                    {Array.from({ length: 2 }).map((_, j) => (
                        <div key={j} className="flex gap-12 shrink-0">
                            <span>Premium THCA</span>
                            <span className="text-highway-red">·</span>
                            <span>South Jersey Delivery</span>
                            <span className="text-highway-red">·</span>
                            <span>Same-Day Drops</span>
                            <span className="text-highway-red">·</span>
                            <span>Slow-Cured Flower</span>
                            <span className="text-highway-red">·</span>
                            <span>Live Resin Diamonds</span>
                            <span className="text-highway-red">·</span>
                            <span>Order on Telegram</span>
                            <span className="text-highway-red">·</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
